export default __webpack_public_path__ + "static/media/logo.a9d26b05.png";